module.exports = __webpack_public_path__ + "8251fe76d7487a28b07603515b300964.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/redux.png
// module id = 1167
// module chunks = 0